export enum DefaultRoutes {
  APP = '/',
}
